@for (toast of toasts; track toast) {
  <div
    [class]="'toast ' + toast.cssClass"
    [ngClass]="{'is-detailed': isToastWithDetails(toast)}"
    (mouseenter)="cancelTimeout(toast)"
    (mouseleave)="restartTimeout(toast)"
    [@toastAnim]>
    <div class="toast_container" (click)="close(toast)">
      <div class="toast_icon" [class]="toast.icon"></div>
      <div class="toast_message">
        @if (hasTitle(toast)) {
          <div class="toast-title">
            {{toast.title}}
          </div>
        }
        @if (toast.content) {
          <div class="toast-content" [ngClass]="{'has-no-title': !hasTitle(toast)}" [innerHTML]="toast.content"></div>
        }
      </div>
    </div>
    @if (isToastWithDetails(toast)) {
      <div class="toast-detail">
        <button class="button-white-icon" (click)="copyToClipboard(toast)">
          <i class="icon icon-clipboard"></i>
        </button>
        <button class="button-white-icon" (click)="fermerToast(toast)">
          <i class="icon icon-x"></i>
        </button>
        @if (isCopyOnClipboard(toast)) {
          <div class="copy-clipboard" [@fadeInOut]>
            Les détails ont été copiés dans votre presse-papier
          </div>
        }
      </div>
    }
  </div>
}
